import { render, staticRenderFns } from "./NewHome.vue?vue&type=template&id=04aeff28&scoped=true"
import script from "./NewHome.vue?vue&type=script&lang=js"
export * from "./NewHome.vue?vue&type=script&lang=js"
import style0 from "./NewHome.vue?vue&type=style&index=0&id=04aeff28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04aeff28",
  null
  
)

export default component.exports